module.exports = __webpack_public_path__ + "img/LOGO-white-2.93e5fc2f.svg";